module.exports = __webpack_public_path__ + "images/dogIcon.8284f8f8.svg";